import axios from 'axios';

/**
 * Flattens a DRF error body into one message per key. Field errors arrive as
 * arrays — `{ new_password: ['Too short.', 'Entirely numeric.'] }` — and
 * everything else lands under `detail`.
 */
export function responseErrors(error: unknown): Record<string, string> {
  const data = axios.isAxiosError(error) ? error.response?.data : undefined;
  if (!data || typeof data !== 'object') return {};

  return Object.fromEntries(
    Object.entries(data as Record<string, unknown>).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.join(' ') : String(value),
    ])
  );
}
